const keyName = `dxAI-`;

/* eslint-disable */
export function guid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
}

/**
 * 判断是否为空
 */
export function validatenull(val: any) {
    if (typeof val === "boolean") {
        return false;
    }
    if (typeof val === "number") {
        return false;
    }
    if (val instanceof Array) {
        if (val.length === 0) return true;
    } else if (val instanceof Object) {
        if (JSON.stringify(val) === "{}") return true;
    } else {
        if (
            val === "null" ||
            val === null ||
            val === "undefined" ||
            val === undefined ||
            val === ""
        )
            return true;
        return false;
    }
    return false;
}

export const setStore = (params: any) => {
    let { name } = params;
    const { content, type } = params;

    name = keyName + name;
    const obj = {
        dataType: typeof content,
        content,
        type,
        datetime: new Date().getTime(),
    };
    if (type) window.sessionStorage.setItem(name, JSON.stringify(obj));
    else window.localStorage.setItem(name, JSON.stringify(obj));
};

export const getStore = (params: any) => {
    let { name } = params;
    const { debug } = params;
    name = keyName + name;
    let obj: any = {};
    let content;
    obj = window.sessionStorage.getItem(name);
    if (validatenull(obj)) obj = window.localStorage.getItem(name);
    if (validatenull(obj)) return;
    try {
        obj = JSON.parse(obj);
    } catch {
        // eslint-disable-next-line consistent-return
        return obj;
    }
    if (debug) {
        // eslint-disable-next-line consistent-return
        return obj;
    }
    if (obj.dataType === "string") {
        content = obj.content;
    } else if (obj.dataType === "number") {
        content = Number(obj.content);
    } else if (obj.dataType === "boolean") {
        content = Boolean(obj.content);
    } else if (obj.dataType === "object") {
        content = obj.content;
    }
    // eslint-disable-next-line consistent-return
    return content;
};

/**
 * 删除localStorage
 */
export const removeStore = (params: any) => {
    let { name } = params;
    const { type } = params;
    name = keyName + name;
    if (type) {
        window.sessionStorage.removeItem(name);
    } else {
        window.localStorage.removeItem(name);
    }
};

/**
 * 清空全部localStorage和sessionStorage
 */
export const clearAllStorage = () => {
    window.sessionStorage.clear();
    const keyMap = Object.keys(localStorage.valueOf());
    keyMap.forEach((item) => {
        if (!item.startsWith("ai-")) {
            localStorage.removeItem(item);
        }
    });
};

// export const getToken = () =>
//     "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJTUFJJTkctQUktQkFDS0VORCIsInN1YiI6IjI5IiwiaWF0IjoxNzI1ODk2MzAwLCJleHAiOjE3MjgzMTU1MDAsInR5cGUiOiJhY2Nlc3MifQ.wQkHPw63cgf__iPCVUqK9jEqjTd_W8ZPROJ7EH9-gMY" // 测试

export const getToken = () => getCookie('Authorization');

// interface UserinfoData {
//     id: string;
//     phone: string;
//     realName: string;
//     avatar: string;
//     role: string;
//     token: string
// }





export const debounce = (func: any, wait: number, immediate?: boolean) => {
    let timeout: any;

    return function executedFunction() {
        // @ts-ignore
        const context = this;
        const args = arguments;

        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}


/**
 * 设置 cookie
 * @param name cookie 名称
 * @param value cookie 值
 * @param days 过期天数，默认为 30 天
 */
export function setCookie(name: string, value: string, days: number = 30): void {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // 设置过期时间
    const expires = `; expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/`;
}

/**
 * 获取 cookie
 * @param name cookie 名称
 */
export function getCookie(cookieName: string): string | null {
    // if (cookieName === 'Authorization') {
    //     return getToken()
    // }
    // if (!name) return null;
    // const nameEQ = `${name}=`;
    // const ca = document.cookie.split(';');
    // console.log('ca=====>', ca)
    // for (let i = 0; i < ca.length; i++) {
    //     let c = ca[i];
    //     while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    //     if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    // }
    // return null;

    if (!cookieName) return null;
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}

/**
 * 删除 cookie
 * @param name cookie 名称
 */
export function removeCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
}
